import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

const ProtectedRoute = ({ allowedRoles = [], children, ...props }) => {
  const userProfile = useSelector((state) => state.profile.userProfile);
  const userRole = userProfile?.type || "";
  const hasAccess =
    allowedRoles.length > 0 ? allowedRoles.includes(userRole) : true;

  if (allowedRoles && !hasAccess) {
    return <Navigate to="/404/invalid_user_type" />;
  }

  return children || <Outlet />;
};

ProtectedRoute.propTypes = {
  allowedRoles: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node.isRequired
};

export default ProtectedRoute;
